import { useSelector } from '@xstate/react';
import { UserContext } from '~/app';
import { useOpportunitiesMachineService } from '~/features/shared/useOpportunitiesMachineService';
import { jobOpportunitiesMachineFor } from './jobOpportunities.machine';
import type { B2BResponsesSide } from './types';

export const useJobOpportunitiesService = (side?: B2BResponsesSide) => {
  const userRef = UserContext.useActorRef();

  // userInfoId (common.user_info.id) is the identity key stamped on
  // JobMessage.sender_user_id by the backend. EmployerUser.id is a different
  // sequence and would mis-classify own messages as received.
  const userInfoId = useSelector(userRef, (s) => s.context.userInfoId);
  const opportunitiesService = useOpportunitiesMachineService(jobOpportunitiesMachineFor(side));

  return {
    userInfoId,
    ...opportunitiesService,
  };
};
